/**
 * The nonce the edge writes into `index.html` on every response (`AM-177`, `SD-13`, `15` §2.17.1).
 *
 * The Content-Security-Policy of the edge has no `'unsafe-inline'` in `style-src`, and Mantine
 * writes `<style>` elements at runtime: the CSS variables of the theme (font, sizes, colours) and
 * the responsive rules of `AppShell` (the navbar offset, the footer hidden from `sm`). Blocked, the
 * console falls back to the library's default theme and the shell overlaps its own content. Caddy
 * generates one value per response, sets it in `style-src 'nonce-…'` and writes the same value
 * into `<meta name="csp-nonce">`; this module reads it once and every `MantineProvider` hands it to
 * the style elements it creates (`getStyleNonce`).
 */
export function readCspNonce(doc: Document = document): string | undefined {
  const value = doc.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';
  // Served without the edge - the Vite dev server, a test - the template is still literal and
  // there is no policy to satisfy.
  return value === '' || value.includes('{{') ? undefined : value;
}

const nonce = readCspNonce();

/** What `MantineProvider` asks for each `<style>` element it writes; empty without an edge in front. */
export const getStyleNonce = (): string => nonce ?? '';
